(ns motorsaif.frontend-routes
  (:require
   #?@(:cljs [[goog.string.format]
              [reitit.coercion.malli :as mc]
              [goog.object]
              [motorsaif.web.utils :as web-utils]
              [motorsaif.shared.events :as events]
              [re-frame.core :as rf :refer [dispatch]]])
   #?@(:clj [[naomarik.motorsaif.web.pages.layout :as layout]])
   [reitit.coercion :as coercion]
   [reitit.core :as r]))

(defn- wrap-scroll-top [m]
  (let [?start-fn (get-in m [:controllers 0 :start])]
    (assoc m :controllers
           [{:start (fn []
                      #?(:cljs
                         (web-utils/scroll-top))
                      (when ?start-fn
                        (?start-fn)))}])))

(defn routes []
  [[""
    #?(:cljs {:coercion mc/coercion})
    #?(:clj {:get layout/home})
    ["/"
     (wrap-scroll-top
      {:name :home
       :nav :home
       :view :home
       :controllers [{:start (fn [_]
                               #?(:cljs
                                  (do
                                    (rf/dispatch [:page/init-home]))))}]})]
    ["/feed"
     {:name :feed
      :nav :feed
      :view :feed
      :controllers [{:start (fn [_]
                              #?(:cljs
                                 (rf/dispatch [:fetch-requests])))}]}]

    ["/business/:id"
     (wrap-scroll-top
      {:name :public-profile
       :view :public-profile
       :parameters {:path [:map [:id int?]]}
       :controllers [{:parameters {:path [:id]}
                      :start
                      #?(:clj nil
                         :cljs
                         (fn [{{id :id} :path}]
                           (do
                             (rf/dispatch [:fetch-businesses])
                             (web-utils/scroll-top))))}]})]

    ["/whatsapp"
     (wrap-scroll-top
      {:name :whatsapp-requests
       :nav :feed
       :view :requests
       :controllers [{:start (fn [_]
                               #?(:cljs
                                  (do
                                    (rf/dispatch [:fetch-requests]))))}]})

     ["/:id"
      {:name :whatsapp-request
       :view :request
       :conflicting true
       :controllers [{:parameters {:path [:id]}
                      :start (fn [{{id :id} :path}]
                               #?(:cljs
                                  (do
                                    (rf/dispatch [:fetch-requests]))))}]
       :parameters {:path [:map [:id string?]]}}]]


    ["/businesses"
     ["/new"
      {:name :new-business
       :view :new-business
       :conflicting true}]

     ["/:id" {:name :business
              :view :business
              :parameters {:path [:map
                                  [:id int?]]}
              :conflicting true}]

     ["/edit/:id"
      {:name :edit-business
       :view :edit-business
       :parameters {:path [:map [:id int?]]}
       :controllers [{:parameters {:path [:id]}
                      :start (fn []
                               #?(:cljs
                                  (do
                                    (rf/dispatch [:fetch-businesses])
                                    (web-utils/scroll-top))))}]
       :conflicting true}]]

    ["/login/google"
     {:name :login-google
      :conflicting true
      :view :login-google}]

    ["/account"
     {:name :account
      :view :account}

     ["/sign-up"
      [""
       (wrap-scroll-top
        {:name :sign-up
         :view :sign-up})]

      ["/personal"
       [""
        (wrap-scroll-top
         {:name :personal-sign-up
          :view :personal-sign-up})]]

      ["/business"
       [""
        (wrap-scroll-top
         {:name :business-sign-up
          :view :business-sign-up
          :hide-mobile-nav true})]

       ["/:step"
        (wrap-scroll-top
         {:name :business-sign-up-step
          :view :business-sign-up
          :parameters {:path [:map [:step string?]]}
          :hide-mobile-nav true})]]]

     ["/forgot-password"
      {:name :forgot-password
       :view :forgot-password}]

     ["/login"
      [""
       {:name :login
        :view :login
        :controllers []}]



      ["/:email"
       {:name :login-email
        :conflicting true
        :view :login
        :parameters {:path [:map [:email string?]]}}]

      #_["/n/:nonce"
         {:name :nonce-login
          :view :login
          :controllers [{:parameters {:path [:nonce]}
                         :start
                         #?(:clj nil
                            :cljs
                            (fn [{{:keys [nonce]} :path}]
                              (do
                                (rf/dispatch [:login {:user/master-nonce nonce}])
                                (web-utils/scroll-top))))}]}]]

     ["/verify-code"
      [""
       {:name :verify-code
        :view :verify-code}]]]

    ["/settings"
     ["/personal"
      {:name :settings-profile
       :view :settings-profile}]

     ["/notifications"
      {:name :settings-notifications
       :view :settings-notifications}]

     ["/business"
      [""
       {:name :settings-business
        :view :settings-business}]

      ["/:step"
       (wrap-scroll-top
        {:name :settings-business-step
         :parameters {:path [:map [:step string?]]}
         :view :settings-business})]]]

    ["/ops"
     [""
      {:name :ops
       :nav :ops
       :view :ops}]

     ["/c/:category"
      (wrap-scroll-top
       {:name :ops-category
        :nav :ops
        :parameters {:path [:map [:category keyword?]]}
        :view :ops-category})]

     ["/chat/:request-id/:owner-id"
      {:name :ops-chat
       :view :ops-chat
       :hide-mobile-nav true
       ;; :nav :requests
       ;; :chat-frame true
       :parameters {:path [:map
                           [:request-id int?]
                           [:owner-id int?]]}
       :controllers [{:parameters {:path [:owner-id :request-id]}
                      :start
                      (fn [{{:keys [request-id]} :path}]
                        #?(:cljs
                           (rf/dispatch [:fetch-requests {:request-id request-id}])))}]}]]

    ["/dashboard/requests"
     [""
      {:name :dash-requests
       :tab :active
       :nav :dash-requests
       :view :dash-requests
       :controllers [{:start (fn [_]
                               #?(:cljs
                                  (do
                                    (dispatch [:set-ui-state :selected-chat nil])
                                    (web-utils/scroll-top))))}]}]

     ["/new"
      (wrap-scroll-top
       {:name :new-request
        :conflicting true
        :view :new-request
        ;; :hide-mobile-nav true
        :controllers [{:parameters {:path [:type]}
                       :start #?(:clj nil
                                 :cljs (fn [p]
                                         nil))}]})]

     ["/history"
      {:name :dash-requests-history
       :tab :history
       :nav :dash-requests
       :conflicting true
       :view :dash-requests
       :controllers [{:start (fn [_]
                               #?(:cljs
                                  (do
                                    (dispatch [:set-ui-state :selected-chat nil])
                                    (web-utils/scroll-top))))}]}]
     ["/:request-id"
      [""
       {:name :dash-request
        :conflicting true
        :view :dash-request
        ;; :nav :requests
        :parameters {:path [:map [:request-id int?]]}
        :controllers [{:parameters {:path [:request-id]}
                       :start
                       (fn [{path :path}]
                         #?(:cljs
                            (dispatch [:set-ui-state :selected-chat path])))}]}]
      ["/edit"
       (wrap-scroll-top
        {:name :dash-edit-request
         :view :dash-edit-request
         :controllers [{:parameters {:path [:map
                                            [:request-id int?]]}
                        :start
                        (fn [{{request-id :id} :path}]
                          #?(:cljs
                             (do
                               (rf/dispatch [:fetch-requests]))))}]
         :parameters {:path
                      [:map
                       [:request-id int?]]}})]

      ["/chat/:owner-id"
       {:name :dash-request-chat
        :view :dash-request-chat
        :hide-mobile-nav true
        ;; :nav :requests
        ;; :chat-frame true
        :parameters {:path [:map
                            [:request-id int?]
                            [:owner-id int?]]}
        :controllers [{:parameters {:path [:owner-id :request-id]}
                       :start
                       (fn [{path :path}]
                         #?(:cljs
                            (dispatch [:set-ui-state :selected-chat path])))}]}]]]

    ;; Public request view
    ["/requests"
     {:controllers [{:start (fn [_]
                              #?(:cljs
                                 (do
                                   (events/ensure-after-bs
                                    #(if @(rf/subscribe [:current-owner-id])
                                       (rf/dispatch [:fetch-messages {:status :active}])
                                       (rf/dispatch  [:common/navigate! :sign-up])))
                                   (dispatch [:set-ui-state :selected-chat nil])
                                   (web-utils/scroll-top))))}]}


     ["/:id"
      {:name :request
       :view :request
       :controllers [{:parameters {:path [:id]}
                      :start (fn [{{id :id} :path}]
                               #?(:cljs
                                  (do
                                    (rf/dispatch [:fetch-requests]))))}]
       :parameters {:path [:map [:id string?]]}}]]

    ["/pwa"
     {:name :pwa
      :conflicting true
      :view :pwa
      :controllers [{:parameters {:path [:id]}
                     :start
                     #?(:clj nil
                        :cljs
                        (fn [{{id :id} :path}]
                          (do
                            (web-utils/scroll-top))))}]}]

    ["/businesses"
     {:name :businesses
      :conflicting true
      :view :generic
      :controllers [{:parameters {:path [:id]}
                     :start
                     #?(:clj nil
                        :cljs
                        (fn [{{id :id} :path}]
                          (do
                            (web-utils/scroll-top))))}]}]

    ["/about"
     {:name :about
      :conflicting true
      :view :generic
      :controllers [{:parameters {:path [:id]}
                     :start
                     #?(:clj nil
                        :cljs
                        (fn [{{id :id} :path}]
                          (do
                            (web-utils/scroll-top))))}]}]
    ["/privacy"
     {:name :privacy
      :conflicting true
      :view :generic
      :controllers [{:parameters {:path [:id]}
                     :start
                     #?(:clj nil
                        :cljs
                        (fn [{{id :id} :path}]
                          (do
                            (web-utils/scroll-top))))}]}]
    ["/terms"
     {:name :terms
      :conflicting true
      :view :generic
      :controllers [{:parameters {:path [:id]}
                     :start
                     #?(:clj nil
                        :cljs
                        (fn [{{id :id} :path}]
                          (do
                            (web-utils/scroll-top))))}]}]

    ["/admin"
     {:name :admin
      :view :admin
      :controllers [{:start (fn [_]
                              #?(:cljs
                                 (rf/dispatch [:admin/fetch-data])
                                 ))}]}
     [""]

     ["/localization"
      {:name :admin-localization
       :view :admin-localization
       :conflicting true}]

     ["/:table"
      [""
       {:name :admin-table
        :view :admin-table
        :conflicting true
        :parameters {:path [:map [:table keyword?]]}}]


      ["/new"
       {:name :admin-new-entity
        :view :admin-new-entity
        :conflicting true}]

      ["/:id"
       {:name :admin-entity
        :view :admin-entity
        :conflicting true
        :parameters {:path [:map
                            [:id int?]
                            [:table keyword?]]}
        :controllers [{:parameters {:path [:id]}
                       :start
                       #?(:clj nil
                          :cljs
                          (fn [{{id :id} :path}]
                            (do
                              (web-utils/scroll-top))))}]}]]


     #_["/businesses"
        {:name :admin-businesses
         :view :admin-businesses
         :controllers [{;; :parameters {:path [:id]}
                        :start
                        #?(:clj nil
                           :cljs
                           (fn [{{id :id} :path}]
                             (do
                               (rf/dispatch [:fetch-businesses])
                               (web-utils/scroll-top))))}]}
        [""]
        ["/new"
         {:name :admin-new-business
          :view :admin-new-business
          :conflicting true}]

        ["/edit/:id"
         {:name :admin-edit-business
          :view :admin-edit-business
          :parameters {:path [:map [:id int?]]}
          :controllers [{:parameters {:path [:id]}
                         :start
                         #?(:clj nil
                            :cljs
                            (fn [{{id :id} :path}]
                              (do
                                (rf/dispatch [:fetch-admin-users])
                                (web-utils/scroll-top))))}]
          :conflicting true}]]
     ]]])

(def router (r/router
             (routes)
             {:compile coercion/compile-request-coercers}))

;; (defn path-for [& args]
;;   (let [path (:path (apply r/match-by-name router args))]
;;     path))

(defn path-for
  ([name]
   (path-for name nil nil))
  ([name path-params]
   (path-for name path-params nil))
  ([name path-params query-params]
   (-> router
       (r/match-by-name name path-params)
       (r/match->path query-params))))
